export default {
  'articleListing.applyFilters': 'Appliquer des filtres',
  'articleListing.filters': 'Filters',
  'articleListing.loadMore': 'Laad meer',
  'brandListing.all': 'Tout',
  'brandListing.byCategories': 'Par catégorie',
  'brandListing.clear': 'Décocher',
  'brandListing.productsAndServices': 'Produits et services',
  'brandListing.seeProductsFor': 'Voir les produits pour',
  'brandListing.similarBrands': 'Marques avec produits et services similaires',
  'brandListing.visitWebsite': 'Visiter le site Web',
  'cards.advice.link': "lire l'article",
  'cards.category.link': 'lire plus',
  'cards.event.link': "voir l'événement",
  'cards.news.link': 'continuer à lire',
  'cards.product.link': 'Voir plus',
  'footer.copyright': '© {year} Arvesta. Tous les droits sont réservés.',
  'footer.follow_us': 'Suivez-nous',
  'footer.newsletter.error': 'l y a eu une erreur avec les informations que vous avez saisies, veuillez réessayer',
  'footer.newsletter.heading':
    'Souhaitez-vous recevoir des nouvelles et des conseils qui correspondent à ce qui vous intéresse? Nous sommes heureux de le faire pour vous!',
  'footer.newsletter.placeholder': 'Entrez votre adresse e-mail',
  'footer.newsletter.subscribe': 'souscrire',
  'footer.newsletter.success': 'Vous êtes abonné, merci. Vous aurez bientôt de nos nouvelles',
  'footer.subscribe.enteremail': 'Entrez votre adresse e-mail',
  'footer.subscribe.failure': 'l y a eu une erreur avec les informations que vous avez saisies, veuillez réessayer',
  'footer.subscribe.invalid_email': 'Pouvez-vous saisir votre adresse e-mail ?',
  'footer.subscribe.subscribe': 'souscrire',
  'footer.subscribe.subscribing': 'Veuillez patienter pendant que nous essayons de nous connecter au serveur',
  'footer.subscribe.success': 'Vous êtes abonné, merci. Vous aurez bientôt de nos nouvelles.',
  'forms.contact.description': 'Remplissez le formulaire ci-dessous et notre équipe vous contactera',
  'forms.contact.email.label': 'adresse électronique',
  'forms.contact.email.placeholder': 'Entrez votre adresse e-mail',
  'forms.contact.errors.email': 'Pouvez-vous saisir votre adresse e-mail ?',
  'forms.contact.errors.required': 'Veuillez remplir ce champ obligatoire',
  'forms.contact.failure': 'l y a eu une erreur avec les informations que vous avez saisies, veuillez réessayer',
  'forms.contact.fullname.label': 'Nom complet',
  'forms.contact.fullname.placeholder': 'Introduisez votre nom complet',
  'forms.contact.message.label': 'Message',
  'forms.contact.message.placeholder': 'Communiquez-nous votre message',
  'forms.contact.newsletter.title':
    'Souhaitez-vous recevoir des nouvelles et des conseils qui correspondent à ce qui vous intéresse? Nous sommes heureux de le faire pour vous!',
  'forms.contact.pageTitle': 'Titre de la page',
  'forms.contact.submit': 'Envoyez',
  'forms.contact.success': 'Merci, nous étudions déjà votre message',
  'forms.contact.title': 'Prenez contact avec nous',
  'globals.download': 'Download',
  'globals.featuredProducts': 'Produits populaires',
  'globals.no': 'Non',
  'globals.yes': 'Oui',
  'header.allAbout': 'Tout savoir sur',
  'header.search.placeholder': 'Chercher',
  'header.selectlanguage': 'Choisir la langue',
  'legacy.cookie.description': 'En continuant à naviguer sur le site, vous acceptez notre utilisation des',
  'legacy.footer.headoffice': 'Siège central',
  'legacy.footer.headquarters': 'Siège social',
  'legacy.header.about': 'à propos de nous',
  'legacy.header.contact': 'contactez-nous',
  'legacy.header.jobs': 'jobs',
  'legacy.header.news': 'nouvelles & presse',
  'legacy.header.products': 'produits & services',
  'newscard.readmore': 'En savoir plus',
  'newsletter.email.error': "S'il vous plaît, mettez une adresse email valide",
  'newsletter.email.success': 'Vous vous êtes abonné avec succès. Vous aurez de nos nouvelles sous peu.',
  'newsletter.input.placeholder': 'Adresse e-mail',
  'newsletter.terms.error': 'Veuillez accepter les conditions générales de confidentialité',
  'newsletter.terms.privacyPolicy': 'conditions de confidentialité',
  'newsletter.terms.sectionOne': 'Je reconnais avoir reçu et lu la',
  'newsletter.terms.sectionTwo': '.',
  'newsletter.terms.subscribe': 'souscrire',
  'product.certifications.title': 'Certifications du produit',
  'sections.advice.loadmore': 'charger plus de conseils',
  'sections.category.loadmore': 'voir plus de produits',
  'sections.contact.offices': "l'offices",
  'sections.contact.openinghours': "Horaires d'ouvertures",
  'sections.contact.salesteam': "l'équipe",
  'sections.contact.viewonmap': 'voir sur la carte',
  'sections.dealer.clear': 'Décocher',
  'sections.dealer.invalidaddress': "Nous n'avons pas pu trouver l'adresse",
  'sections.dealer.loadmore': 'Afficher tout',
  'sections.dealer.maplink': 'voir sur la carte',
  'sections.dealer.placeholder': 'Remplissez le code postal et la localité',
  'sections.dealer.search': 'Rechercher',
  'sections.dealer.total': 'résultats pour',
  'sections.events.loadmore': "charger plus d'événements",
  'sections.events.loadmorepast': "charger plus d'événements passés",
  'sections.news.loadmore': 'charger plus de nouvelles',
  'sections.product.loadmore': 'Voir plus',
  'sections.product.noproductsfoundfor': 'aucun produit trouvé pour',
  'sections.product.table.brochure': 'Brochure',
  'sections.product.table.download': 'Download',
  'sections.product.table.number': 'n°',
  'sections.product.table.product': 'produit',
  'sections.product.table.weight': 'poids',
  'sections.search.events': 'Evénements',
  'sections.search.news': 'Actus',
  'sections.search.noncategorised': 'Non-catégorisé',
  'sections.search.noresults.title': 'résultats pour',
  'sections.search.products': 'products',
  'sections.search.results.title': '{total} résultats pour {query}',
  'sections.search.seeallevents': 'Voir tous les événements ',
  'sections.search.seeallnews': 'Voir toutes les actus',
  'sections.search.seeallproducts': 'Voir tous les produits',
};
